// An outlined card's border inks on hover
export const HoverSx = {
  transition: 'border-color 0.2s',
  '&:hover': {borderColor: 'text.primary'},
};
